/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2018 10up
 * Licensed under the GPL-2.0+ license.
 */

/* global gtmAccountID, Cookiebot */

'use strict';

/**
 * Load the Google Tag Manager scripts
 *
 * @returns {void}
 */
var simsLoadGTM = function() {

	if ( !gtmAccountID.hasOwnProperty( 'account_id' ) || '' === gtmAccountID.account_id ) {
		return;
	}

	( function( window, $ ) {

		console.log( 'gtm script has loaded' );

		// Load the primary GTM script in the head.
		$( 'head:first' ).append( '<!-- Google Tag Manager -->' +
			'<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':' +
			'new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],' +
			'j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=' +
			'\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);' +
			'})(window,document,\'script\',\'dataLayer\',\'' + gtmAccountID.account_id + '\');</script>' +
			'<!-- End Google Tag Manager -->' );

		// Load the noscript after the first body tag.
		$( 'body:first' ).prepend( '<!-- Google Tag Manager (noscript) -->' +
			'<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=' + gtmAccountID.account_id + '" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>' +
			'<!-- End Google Tag Manager (noscript) -->' );

	} )( window, jQuery );
};

( function( window, $ ) {

	simsLoadGTM();

} )( window, jQuery );
